import React from 'react';
import RepayLoan1Component from '../components/repay-loan1';

const RepayLoan1 = () => {
  return <RepayLoan1Component />;
};

export default RepayLoan1;
